/* @flow */
import * as React from "react";
import styled from "styled-components";

import Gettext from "../common/Gettext";
// import ClickOutside from "../common/ClickOutside";
import { rgba } from "polished";

import ToolsMenu from "./ToolsMenu";
import ToolsContent from "./ToolsContent";
import ToolsActive from "./ToolsActive";
import ToolWrapper from "./ToolWrapper";

import AnimationWrapper from "../AnimationWrapper";
import { fontSize } from "../common/styled-mixins";

const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

const Overlay = styled(FlexRow)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  justify-content: center;
  align-items: center;
  align-content: center;
  max-height: 100%;
  transform: translate3d(0, 0, 0);
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.5);
  color: ${({ theme }) => theme.foreground};
  z-index: 100000;
`;

const Popup = styled(FlexRow)`
  justify-content: flex-start;
  align-items: flex-start;
  align-content: flex-start;
  width: 510px;
  min-height: 198px;
  height: auto;
  background-color: ${props => props.theme.popupBackground};
`;

const Header = styled(FlexRow)`
  justify-content: space-between;
  align-content: center;
  align-items: center;
  width: 100%;
  height: 45px;
  padding: 0 15px;
  background-color: ${props => props.theme.popupDarkBackground};
  border-bottom: 1px solid ${props => props.theme.mainSeparator};
`;

const Heading = styled.h2`
  font-size: ${fontSize(16)};
  line-height: 1;
  color: ${({ theme }) => theme.foreground};
`;

const Svg = styled.svg`
  color: ${({ theme }) => rgba(theme.foreground, 0.5)};
  cursor: pointer;
  transition: all 0.3s ease;

  :hover {
    color: ${({ theme }) => theme.foreground};
  }
`;

const Inner = styled(FlexRow)`
  justify-content: flex-start;
  align-items: flex-start;
  align-content: flex-start;
  flex-wrap: nowrap;
  align-self: stretch;
  flex-grow: 1;
  flex-shrink: 1;
  width: 100%;
  height: auto;
`;

type CloseProps = {
  onClick?: () => void
};

export function CloseButton(props: CloseProps) {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      width="21px"
      height="22px"
      viewBox="0 0 21 22"
      onClick={props.onClick}
    >
      <path
        fillRule="evenodd"
        fill="currentColor"
        d="M20.086,2.293 L11.367,11.012 L20.071,19.716 L18.744,21.043 L10.040,12.339 L1.337,21.043 L0.010,19.716 L8.714,11.012 L-0.005,2.293 L1.321,0.967 L10.040,9.686 L18.760,0.967 L20.086,2.293 Z"
      />
    </Svg>
  );
}

type Props = {
  onClick?: () => void
};

function ToolsPopup(props: Props) {
  let activeTool;
  let activeToolParams;

  if (props.instruments) {
    const split = props.instruments.split("?");
    activeTool = split[0];
    activeToolParams = split.length > 1 && split[1].split(":");
  }

  return (
    <Overlay onClick={props.close}>
      <AnimationWrapper>
        <Popup onClick={e => e.stopPropagation()}>
          <Header>
            <Heading>
              <Gettext>Settings</Gettext>
            </Heading>
            <CloseButton onClick={props.onClick} />
          </Header>
          <ToolWrapper
            activeToolInitial={activeTool}
            instrumentsInitial={activeToolParams && activeToolParams[0]}
            activeToolParams={activeToolParams}
            onCompletelyClose={props.onClick}
          >
            {tools => (
              <Inner>
                {tools.instruments === "settings"
                  ? [
                      <ToolsMenu
                        key={1}
                        tools={tools.TOOLS}
                        activeTool={tools.activeTool}
                        changeActiveTool={tools.changeActiveTool}
                      />,
                      <ToolsContent
                        activeTool={tools.activeToolObj}
                        key={2}
                        dispatch={tools.dispatch}
                        settings={tools.settings}
                      >
                        <ToolsActive
                          tools={tools.TOOLS}
                          handlePopupOpen={tools.handlePopupOpen}
                          activeTool={tools.activeTool}
                          dispatch={tools.dispatch}
                          settings={tools.settings}
                        />
                      </ToolsContent>
                    ]
                  : tools.popup}
              </Inner>
            )}
          </ToolWrapper>
        </Popup>
      </AnimationWrapper>
    </Overlay>
  );
}

export default ToolsPopup;



// WEBPACK FOOTER //
// ./src/components/Toolbar/ToolsPopup.js